import emailjs from 'emailjs-com';

export function sendRegistrationEmail({
  user_name,
  registration_number,
  user_email,
  user_type,
  name,
  email,
  isUpdate = false // Default to false for new registrations
}) {
  if (!email) {
    throw new Error("Recipient email (email) is empty");
  }

  // Determine which template to use based on isUpdate
  const templateID = isUpdate ? 'template_symjdon' : 'template_x6yc1i5';

  return emailjs
    .send(
      'service_d0dqafe',
      templateID,
      {
        user_name,
        registration_number,
        user_email,
        user_type,
        name,
        email,
      },
      'CwUBiyAh0zdC3QwU5'
    )
    .then(
      (result) => {
        console.log("EmailJS success:", result);
        alert(isUpdate ? "Profile update email sent successfully!" : "Registration email sent successfully!");
        return result;
      },
      (error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send the email. Please try again.");
        throw error;
      }
    );
}